export const handleEnterKeyDown = (itemId, setActiveCard) => (e) => {
  if (e.key === 'Enter') {
    setActiveCard(itemId);
  }
};


function getPlatform() {
  if (navigator.userAgentData && navigator.userAgentData.platform) {
    // Use userAgentData for Chromium-based browsers
    return navigator.userAgentData.platform;
  } else {
    // Fallback to userAgent for Safari and other browsers
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      return "Android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }
    if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
      return "Mac";
    }
    if (/Win32|Win64|Windows|WinCE/.test(userAgent)) {
      return "Windows";
    }
    if (/Linux/.test(userAgent)) {
      return "Linux";
    }
    return "Unknown";
  }
}

export const deviceType = getPlatform();

